// base=/etc/designs/header/clientlibs/desktop/js

// -----------------------------------------------------------------------------
// TERRIFIC MODULES - A-Z PLEASE
// -----------------------------------------------------------------------------
// Modern modules (using imports/exports)

import HeaderLvl2 from 'lib/header/Tc.Module.HeaderLvl2';
import MDD from 'lib/header/Tc.Module.MDD';
import SharedHeader from 'lib/header/Tc.Module.SharedHeader';

const modernTcModules = {
	HeaderLvl2,
	MDD,
	SharedHeader,
};

// Tc Bootstrap
import { legacyBootstrapDeferredSingleton } from 'bootstrap/load-terrific';
legacyBootstrapDeferredSingleton(modernTcModules);



// WEBPACK FOOTER //
// typescript://../clientlibs/js/by-category/scs.header.shared.ts